module.exports = __webpack_public_path__ + "img/logo.2215789e.svg";